/**
 * 메가 드롭다운 열기/닫기 제어.
 * CSS :hover 만으로는 position:fixed 드롭다운 패널 위를 마우스가 지나갈 때
 * 다른 li가 동시에 hover 상태가 되어 두 드롭다운이 동시에 표시되는 버그가 발생한다.
 * mouseenter/mouseleave + is-dropdown-open 클래스로 정확하게 한 번에 하나만 열리도록 제어한다.
 */
export class NavDropdownController {
    private static items: NodeListOf<HTMLElement>;
    private static activeItem: HTMLElement | null = null;

    static init(): void {
        this.items = document.querySelectorAll<HTMLElement>(
            ".site-header .cms-menu__list--depth-0 > .cms-menu__item",
        );
        if (!this.items.length) return;

        this.items.forEach((li) => this.bindItem(li));

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") this.closeAll();
        });
        document.addEventListener("click", (e) => {
            if (!(e.target as Element).closest(".site-header .cms-menu__item")) {
                this.closeAll();
            }
        });
    }

    private static bindItem(li: HTMLElement): void {
        const dropdown = li.querySelector<HTMLElement>(".site-header__dropdown");
        if (!dropdown) return;

        li.addEventListener("mouseenter", () => this.open(li));

        li.addEventListener("mouseleave", (e) => {
            const to = (e as MouseEvent).relatedTarget as Node | null;
            if (!dropdown.contains(to)) this.close(li);
        });

        dropdown.addEventListener("mouseleave", (e) => {
            const to = (e as MouseEvent).relatedTarget as Node | null;
            if (!li.contains(to)) this.close(li);
        });
    }

    private static open(li: HTMLElement): void {
        if (this.activeItem && this.activeItem !== li) {
            this.close(this.activeItem);
        }
        li.classList.add("is-dropdown-open");
        this.activeItem = li;
    }

    private static close(li: HTMLElement): void {
        li.classList.remove("is-dropdown-open");
        if (this.activeItem === li) this.activeItem = null;
    }

    private static closeAll(): void {
        this.items.forEach((li) => this.close(li));
    }
}
